<template>
  <div class="tkBanner">
    <tk-link
      :href="href"
      :target="target"
    >
      <tk-image
        class="tkBanner_image"
        :image-path="imagePath"
        :alt="alt"
      />
    </tk-link>
  </div>
</template>

<script>
import { TkLink, TkImage } from '@ota-frontend/ui'

export default {
  name: 'TkBanner',
  components: {
    TkLink,
    TkImage,
  },
  props: {
    target: {
      type: String,
      default: null,
    },
    href: {
      type: String,
      required: true,
    },
    imagePath: {
      type: String,
      required: true,
    },
    alt: {
      type: String,
      required: true,
    }
  },
}
</script>

<style scoped lang="scss">
  .tkBanner_image {
    width: 100%;
    height: auto;
  }
</style>
